<template>
	<div class="row contentblock">
		<div class="columns contentblock-column">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="columns contentblock-column">
			<div class="contentblock-content">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.row {
	margin: 12px auto !important;
	padding-bottom: 12px;
}

.contentblock {
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	padding: 0 70px;
	max-width: 1680px;
	gap: 12px;

	// &:nth-child(odd) {
	// 	flex-direction: row-reverse;
	// }

	.columns {
		display: flex;
		flex-direction: column;
		padding: 0;
	}

	picture,
	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.contentblock-content {
		padding: 20px 30px;
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;

		:deep(p) {
			line-height: 28px;
		}
	}

	.contentblock-column {
		width: calc(50% - 6px);
		background: #fff;
	}
}

@media (max-width: 1080px) {
	.contentblock {
		.contentblock-column {
			width: 100%;
			background: #fff;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		display: flex;
		flex-direction: column;
		padding: 0;

		.contentblock-column {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden; // Ensures no extra space issues
		}

		picture,
		img {
			aspect-ratio: 1; // Ensures a square shape
			width: 100%;
			height: 100%;
			object-fit: cover; // Ensures the image fully covers the square
		}

		.contentblock-content {
			padding-left: 20px;
			padding-right: 20px;
		}
	}
}
</style>
